import {Component, EventEmitter, Input, input, Output} from '@angular/core';
import {DropdownSimpleV2Component} from '@ui-app/components/dropdown-simple-v2/dropdown-simple-v2.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {UIComponentsModule} from '@ui-app/app.module';
import {BaseFieldComponent} from '@employee-pages/shared/components/fields-for-forms/base-field.component';
import {UsersService} from '../../../../../core/services/data-access/users.service';
import {IFunctionsDto} from '@employee-models/data.models';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
    selector: 'employee-entity-fss',
    standalone: true,
    imports: [
        DropdownSimpleV2Component,
        FormsModule,
        ReactiveFormsModule,
        UIComponentsModule
    ],
    templateUrl: './entity-fss.component.html',
    styleUrl: './entity-fss.component.less'
})
export class EntityFssComponent extends BaseFieldComponent {
    controlKey = input('entityOrFssId');
    controlKeyName = input('entityOrFssName');
    disabled = input(false);
    @Input() functionsFullList: IFunctionsDto[] = [];
    //Output() valueChange = new EventEmitter<void>();
    @Output() valueChange = new EventEmitter<any>(); // Ensure this matches the base class

    functionsList: string[] = [];

    constructor(
        private usersService: UsersService) {
        super();
    }

    ngOnInit(): void {
        if (!this.functionsFullList.length) {
            this.usersService.getFunctions()
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(data => {
                    this.functionsFullList = data;
                    super.ngOnInit();
                });
        } else {
            super.ngOnInit();
        }
    }

    onSelectionChange(entityOrFssName: string): void {
        this.selectedValue = entityOrFssName;
        this.parentForm.patchValue({
            [this.controlKeyName()]: entityOrFssName,
            [this.controlKey()]: this.functionsFullList
                .find((item) => item.name === String(entityOrFssName))?.employeeFunctionId
        });
        this.parentForm.markAsDirty(); // Mark the form as dirty
        this.valueChange.emit(entityOrFssName); // Emit the selected value
    }

    protected initControl(): void {
        this.functionsList = this.functionsFullList.map(item => item.name);
        this.selectedValue = this.functionsFullList
            .find((item) => String(item.employeeFunctionId) === String(this.defaultValue))?.name;
        super.initControl();
    }


}
